export default [
  {
    path: '/campos-servicio',
    name: 'campos-servicio',
    component: () => import(/* webpackChunkName: "campos-servicio" */ '@/pages/campos/CamposPage.vue'),
    meta: { requiresAuth: true }
  }
]
